import numeral from 'numeral';

const getNumberLocale = (currency?: string) => {
  switch (currency) {
    case 'EUR':
      return 'de-DE';
    case 'JPY':
      return 'ja-JP';
    case 'GBP':
      return 'en_GB';
    case 'INR':
      return 'ta_IN';
    case 'USD':
    default:
      return 'en-US';
  }
};

const monthCostFormat = (currency?: string) =>
  Intl.NumberFormat(getNumberLocale(currency), {
    style: 'currency',
    currency: currency ?? 'USD',
    maximumFractionDigits: 0,
  });

const sessionCostFormat = (currency?: string) =>
  Intl.NumberFormat(getNumberLocale(currency), {
    style: 'currency',
    currency: currency ?? 'USD',
    maximumFractionDigits: 2,
  });

const percentFormat = '0.[0]%';

export const formatMonthCost = (item: number, currency?: string) =>
  monthCostFormat(currency).format(item);

export const formatSessionCost = (item: number, currency?: string) =>
  sessionCostFormat(currency).format(item);

export const formatPercents = (item: number) =>
  numeral(item).format(percentFormat);
